import {
  ApplicationRef,
  DOCUMENT,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider
} from '@angular/core';
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { MessageBarContainerComponent } from './components/message-bar-container.component';

export function provideMessageBars(): Array<EnvironmentProviders | Provider> {
  return [
    provideEnvironmentInitializer(() => {
      const document = inject(DOCUMENT);
      const appRef = inject(ApplicationRef);
      const outlet = new DomPortalOutlet(document.body, appRef)

      const portal = new ComponentPortal(MessageBarContainerComponent);
      outlet.attach(portal);
    })
  ]
}
